// Prüft einen einzelnen Eintrag aus selbstbehaltTK/selbstbehaltVK gegen die Berechtigungen des
// Accounts. hasRisk übergibt der Aufrufer, damit hasRiskFactors nicht pro Option erneut läuft.
module.exports = function isSelbstbehaltAllowed (selbstbehalt, { can, hasRisk }) {
  if (!selbstbehalt) return false
  const isAllowedBy = scenarioIds => scenarioIds.some(scenarioId => can(scenarioId))
  if (selbstbehalt.restrictToScenarioIds && !isAllowedBy(selbstbehalt.restrictToScenarioIds)) return false
  if (hasRisk && selbstbehalt.restrictToScenarioIdsOnRisk && !isAllowedBy(selbstbehalt.restrictToScenarioIdsOnRisk)) return false
  return true
}
